import { Box } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Tooltip from "./Tooltip";

function TruncatedTooltipText({ text }: { text: string }) {
	const textRef = useRef<HTMLDivElement | null>(null);
	const [isTrimmed, setIsTrimmed] = useState(false);

	useEffect(() => {
		const setTrimState = () => {
			const element = textRef.current;
			if (!element) {
				setIsTrimmed(false);
				return;
			}

			setIsTrimmed(element.scrollWidth > element.clientWidth);
		};

		setTrimState();
		window.addEventListener("resize", setTrimState);

		return () => {
			window.removeEventListener("resize", setTrimState);
		};
	}, [text]);

	return (
		<Box maxW="100%" w="100%" minW="0">
			<Tooltip content={isTrimmed ? text : undefined}>
				<Box
					ref={textRef}
					maxW="100%"
					w="100%"
					minW="0"
					overflow="hidden"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
				>
					{text}
				</Box>
			</Tooltip>
		</Box>
	);
}

export default TruncatedTooltipText;
